import {PageTemplate} from '../../shared/layout/PageTemplate';
import {Profile} from "./components/Profile";
import {ChangePassword} from "./components/ChangePassword";
import {useTranslation} from "react-i18next";

export function ProfileTemplate() {
    const {t} = useTranslation()
    return <PageTemplate pageName={`${t('profile.profile')}`} title={`${t('profile.profile')}`} content={<Profile/>}/>
    return <PageTemplate pageName="ChangePassword" title="Change Password" content={<ChangePassword/>}/>
}